import React from 'react';
import { createComponent } from '@lit/react';
import { IxSubMenu as LitComp } from '../IxSubMenu.js';

customElements.define('ix-sub-menu', LitComp);

export const IxSubMenu = createComponent({
  tagName: 'ix-sub-menu-react',
  elementClass: LitComp,
  react: React,
});
